module.exports = __webpack_public_path__ + "img/callipers2.cb2cbb72.png";